import React from "react";

import styles from "./MaskedSecretValue.module.css";

const MASK = "•".repeat(12);

/**
 * Mask rendered where a secret's value would otherwise appear. Fetches
 * nothing: the bullets are a fixed-length constant and reveal nothing about
 * the real value, not even its length.
 *
 * The bullets are `aria-hidden` because a screen reader would announce them
 * one character at a time. The `sr-only` text carries the meaning instead.
 */
export const MaskedSecretValue: React.FC = () => (
  <>
    <span className="sr-only">Value hidden</span>
    <span
      className={styles.mask}
      aria-hidden="true"
      title="Secret values are hidden in the web app"
    >
      {MASK}
    </span>
  </>
);
